import Main from './main';
import Edit from './edit';
import Single from './single';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/edit',
    Component: Edit,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id',
    Component: Single,
    props: {
      exact: true,
    },
  },
  {
    path: '/new',
    Component: Edit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
